import { graphql } from "react-relay";

export const PUBLISHINGV2_FRAGMENT = graphql`
	fragment educationalOfferPublishing_PublishingV2Fragment on PublishingV2 {
		id
		initiatedAt
		finishedAt
		messages {
			timestamp
			message
			additionalMessage
		}
		status
	}
`;
